/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab/CloseAction",
  selected
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabTypeValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'type',
format: fromHelpers.canBeClosed,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(tabTypeValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 selected={selected}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}